module.exports = __webpack_public_path__ + "img/mf.3a2e388a.svg";